import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/by/")({
  head: () => routeHead('AGAPE — Маштабуйце МСП з AI і аўтаматызацыяй', META_DESCRIPTIONS.home.by, '/by'),
  component: Index,
});
